import { Denom } from '../Denom';
import { JSONSerializable } from '../../util/json';
import { Dec } from '../numeric';
import { ValAddress } from '../strings';

export class ExchangeRateVote extends JSONSerializable<ExchangeRateVote.Data> {
  constructor(
    public exchange_rate: Dec,
    public denom: Denom,
    public voter: ValAddress
  ) {
    super();
  }

  public static fromData(data: ExchangeRateVote.Data): ExchangeRateVote {
    const { exchange_rate, denom, voter } = data;
    return new ExchangeRateVote(new Dec(exchange_rate), denom, voter);
  }

  public toData(): ExchangeRateVote.Data {
    const { exchange_rate, denom, voter } = this;
    return {
      exchange_rate: exchange_rate.toString(),
      denom,
      voter,
    };
  }
}

export namespace ExchangeRateVote {
  export interface Data {
    exchange_rate: string;
    denom: Denom;
    voter: ValAddress;
  }
}
